module.exports = __webpack_public_path__ + "img/logo-milos-gscv.d5962bfd.png";